export const MULTI_PLACEMENT_ID = 'multi-placement';
export const HOME_MENU_PLACEMENT_ID = 'home-menu';
export const COMMAND_BAR_PLACEMENT_ID = 'command-bar';
export const URL_PLACEMENT_ID = 'url';
export const PORTAL_PLACEMENT_ID = 'portal';
export const SLACK_PLACEMENT_ID = 'slack';

export const HOME_MENU_ICON = 'tool-home-menu';
export const COMMAND_BAR_ICON = 'tool-command-bar';
export const URL_ICON = 'tool-url';

export const TOOL_PREFERENCES_COMMAND_BAR_FLAG = 'command_bar_enabled';
export const TOOL_PREFERENCES_URL_FLAG = 'url_enabled';
export const TOOL_PREFERENCES_SLACK_FLAG = 'slack_enabled';

export const TOOL_PREFERENCES_FLAGS_TO_CONTENT = {
	[TOOL_PREFERENCES_COMMAND_BAR_FLAG]: { icon: COMMAND_BAR_ICON, title: 'Command' },
	[TOOL_PREFERENCES_URL_FLAG]: { icon: URL_ICON, title: 'URL' },
	[TOOL_PREFERENCES_SLACK_FLAG]: { icon: COMMAND_BAR_ICON, title: 'Slack' },
};

export const TOOL_TITLE_OF_TOOL_PLACEMENT = {
	[COMMAND_BAR_PLACEMENT_ID]: 'command bar',
	[URL_PLACEMENT_ID]: 'URL',
	[SLACK_PLACEMENT_ID]: 'Slack',
};
export const WORKFLOW_TITLE_FOR_TOOL_PLACEMENT = {
	[COMMAND_BAR_PLACEMENT_ID]: `in the ${TOOL_TITLE_OF_TOOL_PLACEMENT[COMMAND_BAR_PLACEMENT_ID]}`,
	[URL_PLACEMENT_ID]: `at a ${TOOL_TITLE_OF_TOOL_PLACEMENT[URL_PLACEMENT_ID]}`,
	[SLACK_PLACEMENT_ID]: `in Slack`,
};

export const DEFAULT_OTHER_TOOL_PLACEMENT_TITLE = 'other placement';
